// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Config from "../../../../../Config.bs.js";
import * as DriverLeadRepo from "./DriverLeadRepo.bs.js";
import * as DummyDriverLeadRepo from "./DummyDriverLeadRepo.bs.js";

function getRepo(param) {
  var match = Config.Env.env;
  if (match === "development") {
    return DummyDriverLeadRepo.DriverLeadRepo;
  } else {
    return DriverLeadRepo.DriverLeadRepo;
  }
}

export {
  getRepo ,
  
}
/* Config Not a pure module */
